export default {
  methods: {
    scrollDown() {
      const albumHeader = document.getElementById('album-header');

      if (albumHeader) {
        window.scrollTo({
          top: document.getElementById('album-header').clientHeight,
          behavior: 'smooth',
        });
      }
    }
  }
};